import { Component, Input, OnChanges } from '@angular/core';
import { FuelcellChannelAddress } from '../../shared/interfaces/fuelcell-data.interface';

/**
 * Settings and commands of the fuel cell of a route station: cartridges (with the
 * external fuel sensor), system state and battery configuration. Each section reads
 * its current data itself and initialises its inputs with it.
 */
@Component({
  selector: 'avs-fuelcell-control-settings',
  templateUrl: './fuelcell-control-settings.component.html',
  styleUrls: ['./fuelcell-control-settings.component.css']
})
export class FuelcellControlSettingsComponent implements OnChanges {
  @Input() routeStationId?: string;
  /** DE channel of the fuel cell of the route station */
  @Input() deChannel?: number;

  /** Addressing of the fuel cell channel; one object per input change, as the sections reload on change */
  public target?: FuelcellChannelAddress;

  public ngOnChanges(): void {
    this.target = this.routeStationId && this.deChannel != null
      ? { id: this.routeStationId, deChannel: this.deChannel }
      : undefined;
  }
}
